'use client'

import React from 'react'
import { Container } from '@/components/design-system/Container'
import SchemaScript from '@/components/common/SchemaScript'
import { Locale } from '@/constants/locales'
import { getRoute } from '@/lib/navigation'

interface PageWrapperProps {
    children: React.ReactNode
    locale: Locale
    slug: string
}

const PageWrapper: React.FC<PageWrapperProps> = ({
    children,
    locale,
    slug
}) => {
    const [, route] = getRoute(slug, locale, { fullMatch: false });

    return (
        <>
            <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 py-12">
                <Container>
                    {children}
                </Container>
            </div>

            <SchemaScript route={route} locale={locale as Locale} />
        </>
    )
}

export default PageWrapper;
